/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Track_StartInputs */

const en_cp_track_start = /** @type {(inputs: Cp_Track_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starting point`)
};

const id_cp_track_start = /** @type {(inputs: Cp_Track_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titik mulai`)
};

/**
* | output |
* | --- |
* | "Starting point" |
*
* @param {Cp_Track_StartInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_track_start = /** @type {((inputs?: Cp_Track_StartInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Track_StartInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_track_start(inputs)
	return en_cp_track_start(inputs)
});